import type { CityFile } from '../cityFile';
import type { Opportunity } from '../opportunity';
import { buildIcs } from './ics';
import type { SavedStatus } from './savedList';

/**
 * The calendar file for a saved list: Going as CONFIRMED, Maybe as TENTATIVE,
 * in start order. The app's download and the subscription feed
 * (`functions/calendar/[ids].ics.ts`) both build it here, so the two can never
 * disagree. Ids the city file no longer lists are left out.
 */
export function calendarFeed(file: Pick<CityFile, 'opportunities' | 'cityShort' | 'timezone'>, saved: ReadonlyMap<string, SavedStatus>): string {
  const byStart = (a: Opportunity, b: Opportunity) => Date.parse(a.startsAt) - Date.parse(b.startsAt);
  const listed = file.opportunities.filter((o) => saved.has(o.id)).sort(byStart);
  return buildIcs({
    scheduled: listed.filter((o) => saved.get(o.id) === 'going'),
    saved: listed.filter((o) => saved.get(o.id) === 'maybe'),
    calendarName: `CommonGround ${file.cityShort}`,
    timezone: file.timezone,
  });
}
